import {  Button, DialogActions, DialogContent,  } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import usePostRequest from '../../hooks/usePostRequest';
import useRole from '../../hooks/useRole';
import { isHttpStatusSuccess } from '../../Utils/utils';

const PresTationSuppDialog = ({ handleClose, open ,cra}) => {

    PresTationSuppDialog.propTypes = {
        open: PropTypes.any,
        cra: PropTypes.any,
        handleClose: PropTypes.func,
    };
    const {postDataSilently}= usePostRequest();
    const { i18n } = useTranslation();
    const navigate= useNavigate();
    const [wasCraXCreated, setwasCraXCreated] = useState(false);
    const [createdCraX, setcreatedCraX] = useState(false);
    const role=useRole();

    useEffect(() => {
        getCraXByCraId(cra?._id);
    }, [cra]);

    const getCraXByCraId = async (craId) => {
        try {
            const response1 = await postDataSilently({
                url: '/cra/getCraXByCraId',
                payload: {
                    craId
                }
            });
            console.log(response1);
            if(isHttpStatusSuccess(response1.responseStatus)){
                setwasCraXCreated(true);
                setcreatedCraX(response1.data);
            }
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <Dialog
            // maxWidth='lg'
            open={open}
            // TransitionComponent={Transition}
            onClose={handleClose}
        >
            <DialogContent>
                <h4>
                    {i18n.t('Votre CRA a été validé avec succès!')}
                </h4>
                <p>{wasCraXCreated ? i18n.t('Avez-vous des modifications à faire sur le CRA de la prestation complémentaire?') :
                    i18n.t('Avez vous des astreintes, des HNO ou notes de frais à ajouter?')}</p>
            </DialogContent>
            <DialogActions>
                <Button
                    variant='text'
                    onClick={()=>{
                        navigate(`/${role}/AllCras`);
                    }
                    }
                >{i18n.t('Non')} </Button>
                {wasCraXCreated ?
                    <Button
                        variant='contained'
                        onClick={() => {
                            if (location.pathname.includes('craVente'))
                                navigate(`/${role}/craXVente/${createdCraX?._id}`,
                                    {
                                        state: cra
                                    });
                            else
                                navigate(`/${role}/CraX/${createdCraX?._id}`,
                                    {
                                        state: cra
                                    });

                        }}
                    >{i18n.t('Oui')}</Button>
                    :
                    <Button
                        variant='contained'
                        onClick={() => {
                            if (location.pathname.includes('craVente'))
                                navigate(`/${role}/craXVente`,
                                    {
                                        state: cra
                                    });
                            else
                                navigate(`/${role}/CraX`,
                                    {
                                        state: cra
                                    });

                        }}
                    >{i18n.t('Oui')}</Button>
                }
            </DialogActions>
        </Dialog>
    );
};

export default PresTationSuppDialog;
